import { Booking } from '../models/Booking'
import { Charge } from '../models/Charge'
import { Estimate } from '../models/Estimate'
import { Gift } from '../models/Gift'
import { Invoice } from '../models/Invoice'
import { Package } from '../models/Package'
import { RecordDataMap } from '../models/RecordDataMap'

export const getTransactionDocument = (record: RecordDataMap) => {
    const tranType = record.valueForKey('trantype')
    const tranDoc = {
        booking: record.valueForRecordKey<Booking>('trandoc', Booking),
        invoice: record.valueForRecordKey<Invoice>('trandoc', Invoice),
        charge: record.valueForRecordKey<Charge>('trandoc', Charge),
        estimate: record.valueForRecordKey<Estimate>('trandoc', Estimate),
        package: record.valueForRecordKey<Package>('trandoc', Package),
        gift: record.valueForRecordKey<Gift>('trandoc', Gift),
    }[tranType || '']
    return tranDoc
}
